import React from 'react'
import styles from './DailyWotd.module.css';

const DailyWotdFooter = () => {
  return (
    <div className={styles.footerContainer}>
      <h1 className={styles.footerTitle}>IT'S FREE!</h1>
      <h4 className={styles.footerSubTitle}>No download or sign-up required.</h4>
    </div>
  )
}

export default DailyWotdFooter